import { render, staticRenderFns } from "./ManageClaimsProvider.vue?vue&type=template&id=8cca80e6&"
import script from "./ManageClaimsProvider.vue?vue&type=script&lang=js&"
export * from "./ManageClaimsProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports